export default __webpack_public_path__ + "static/media/B0_3.c57f4b85.mp3";